import React, { useEffect, useState } from "react";
import AttendancePopup from "./Attendence.js";
import SalarySlipPopup from "./SalarySlipPopup.jsx";
import AddStaffModal from "./AddStaffModal.js";
import config from "../../config.js";
import toast, { Toaster } from "react-hot-toast";
import { IconButton, Switch } from "@mui/material";
import { Delete, Edit, Upload, Close, CloudUpload } from "@mui/icons-material";
import VertNav from "./VertNav.js";
import Header from "./Header.js";
import EditStaff from "./EditStaff.js";

const AdminManagement = () => {
    const [staffData, setStaffData] = useState([]);
    const [showAttendancePopup, setShowAttendancePopup] = useState(false);
    const [showSalarySlipPopup, setShowSalarySlipPopup] = useState(false);
    const [showAddStaffModal, setShowAddStaffModal] = useState(false);
    const [selectedStaffId, setSelectedStaffId] = useState(null);
    const [staffId, setStaffId] = useState("");
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [showEditStaff, setShowEditStaff] = useState(false);
    const [selectedStaff, setSelectedStaff] = useState(null);
    const user = JSON.parse(localStorage.getItem("user"));
    const userType = user.type;
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [selectedDevice, setSelectedDevice] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState("");
    const [showUploadResultModal, setShowUploadResultModal] = useState(false);
    const [uploadResultData, setUploadResultData] = useState(null);
    const [toggleConfirm, setToggleConfirm] = useState(null);
    const deviceOptions = [
        { value: "xyz", label: "xyz" },
        { value: "hfs", label: "HFS" },
        { value: "other", label: "Other" },
    ];

    const getDaysInMonth = (month, year) => {
        const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        const isLeapYear =
            (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
        return isLeapYear && month === 1 ? 29 : daysInMonth[month];
    };

    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();

    useEffect(() => {
        const fetchData = async () => {
            const token = localStorage.getItem("token");
            const bid = localStorage.getItem("branch_id");
            try {
                const response = await fetch(
                    `${config.apiUrl}/api/swalook/staff/?branch_name=${bid}`,
                    {
                        headers: {
                            Authorization: `Token ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }

                const data = await response.json();
                console.log("API Response:", data);

                const attendanceResponse = await fetch(
                    `${
                        config.apiUrl
                    }/api/swalook/staff/attendance/?branch_name=${bid}&month=${
                        new Date().getMonth() + 1
                    }`,
                    {
                        headers: {
                            Authorization: `Token ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (!attendanceResponse.ok)
                    throw new Error("Failed to fetch attendance");
                const attendanceData = await attendanceResponse.json();
                console.log("Attendance Response:", attendanceData);

                const staffArray = Array.isArray(data.table_data)
                    ? data.table_data
                    : [];
                const totalDays = attendanceData.current_month_days;
                console.log("Total Days:", totalDays);
                const attendanceTable = attendanceData.table_data || {};
                console.log("dsbhj", attendanceTable);

                if (staffArray.length === 0) {
                    console.warn("No staff data found in table_date.");
                }
                const formattedData = staffArray.map((staff) => {
                    const attendanceRecord = attendanceTable[
                        staff.mobile_no
                    ] || { number_of_days_present: 0 };

                    return {
                        id:
                            staff.staff_data.id ||
                            staff.staff_data.staff_id ||
                            null,
                        name: staff.staff_data.staff_name || "N/A",
                        role: staff.staff_data.staff_role || "N/A",
                        mobile: staff.staff_data.mobile_no || "N/A",
                        salary:
                            parseFloat(staff.staff_data.staff_salary_monthly) ||
                            0,
                        commission:
                            parseFloat(staff.staff_data.staff_slab) || 0,
                        attendance: {
                            present: attendanceRecord.number_of_days_present,
                            total: totalDays,
                        },
                        business:
                            parseFloat(
                                staff.staff_data.business_of_the_current_month
                            ) || 0,
                        advance: parseFloat(staff.current_month_total) || 0,
                        active: staff.staff_data.active, // This was the issue - it should be staff.staff_data.active
                    };
                });

                console.log("Formatted Staff Data:", formattedData);
                setStaffData(formattedData);
            } catch (error) {
                console.error("Error:", error);
                setStaffData([]);
            }
        };

        fetchData();
    }, []);

    const handleEditStaff = (staff) => {
        setSelectedStaff(staff);
        setShowEditStaff(true);
    };

    const handleSaveEditedStaff = (updatedStaff) => {
        setStaffData((prevData) =>
            prevData.map((staff) =>
                staffData.id === selectedStaff.id
                    ? { ...staff, ...updatedStaff }
                    : staff
            )
        );
        toast.success("staff detail updated successfully");
    };

    const handleAttendanceMarked = (staffId, attendanceData) => {
        setStaffData((prevData) =>
            prevData.map((staff) => {
                if (staff.id === staffId) {
                    const updatedAttendance = {
                        ...staff.attendance,
                        present: attendanceData.filter((date) => date.attend)
                            .length,
                    };
                    return { ...staff, attendance: updatedAttendance };
                }
                return staff;
            })
        );
    };

    const openDeleteConfirm = (staffId) => {
        setStaffId(staffId);
        setDeleteConfirmation(true);
    };

    const handleDeleteStaff = async () => {
        const token = localStorage.getItem("token");
        try {
            const response = await fetch(
                `${config.apiUrl}/api/swalook/staff/?id=${staffId}`,
                {
                    method: "DELETE",
                    headers: {
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            setStaffData((prevData) =>
                prevData.filter((staff) => staff.id !== staffId)
            );
            setDeleteConfirmation(false);
            toast.success("Staff deleted successfully");
        } catch (error) {
            console.error("Error deleting staff:", error);
            toast.error("Failed to delete staff");
        }
    };

    const openAttendancePopup = (staffId) => {
        setSelectedStaffId(staffId);
        setShowAttendancePopup(true);
    };

    const openSalarySlipPopup = (staffId) => {
        setSelectedStaffId(staffId);
        setShowSalarySlipPopup(true);
    };

    const handleAddStaff = (newStaff) => {
        console.log("Staff added:", newStaff);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            setFileName(file.name);
        }
    };

    const handleRemoveFile = () => {
        setSelectedFile(null);
        setFileName("");
    };

    const handleUpload = async () => {
        if (!selectedFile || !selectedDevice) {
            toast.error("Please select both device and file");
            return;
        }

        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("device", selectedDevice);
        formData.append("branch_id", localStorage.getItem("branch_id"));

        const token = localStorage.getItem("token");
        try {
            // const response = await fetch(`${config.apiUrl}/api/swalook/upload-attendance/`, {
            //     method: "POST",
            //     headers: {
            //         Authorization: `Token ${token}`,
            //     },
            //     body: formData,
            // });

            // if (!response.ok) {
            //     throw new Error("Upload failed");
            // }

            // const data = await response.json();
            toast.success("Attendance uploaded successfully!");

            // Close the upload modal
            setShowUploadModal(false);

            setUploadResultData({
                dateFrom: "2023-05-01",
                dateTo: "2023-05-31",
                employees: [
                    {
                        name: "John Doe",
                        inTime: "09:00 AM",
                        outTime: "06:00 PM",
                    },
                    {
                        name: "Jane Smith",
                        inTime: "09:15 AM",
                        outTime: "05:45 PM",
                    },
                    // Add more employee data as needed
                ],
            });

            // Show the result modal
            setShowUploadResultModal(true);
        } catch (error) {
            console.error("Error uploading file:", error);
            toast.error("Failed to upload attendance file");
        }
    };

    // --- === Enable/Disable Toggle Handler === ---
    const handleToggleActive = async (staff) => {
        const token = localStorage.getItem("token");
        const bid = localStorage.getItem("branch_id");
        const action = staff.active ? "Disable" : "Enable";

        // Show toast confirmation instead of window.confirm
        toast.custom(
            (t) => (
                <div
                    className={`${
                        t.visible ? "animate-enter" : "animate-leave"
                    } 
                max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
                >
                    <div className="flex-1 w-0 p-4">
                        <div className="flex items-start">
                            <div className="ml-3 flex-1">
                                <p className="text-sm font-medium text-gray-900">
                                    Confirm {action}
                                </p>
                                <p className="mt-1 text-sm text-gray-500">
                                    Are you sure you want to{" "}
                                    {action.toLowerCase()} staff: {staff.name}?
                                </p>
                            </div>
                        </div>
                        <div className="flex gap-3 mt-4">
                            <button
                                onClick={() => {
                                    toast.dismiss(t.id);
                                    proceedWithToggle(staff, action);
                                }}
                                className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700"
                            >
                                Yes
                            </button>
                            <button
                                onClick={() => toast.dismiss(t.id)}
                                className="px-4 py-2 bg-gray-300 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-400"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            ),
            {
                duration: Infinity, // Stays until manually dismissed
            }
        );
    };

    const proceedWithToggle = async (staff, action) => {
        const token = localStorage.getItem("token");
        const bid = localStorage.getItem("branch_id");

        try {
            const response = await fetch(
                `${config.apiUrl}/api/swalook/staff/?id=${staff.id}&branch_name=${bid}`,
                {
                    method: "PUT",
                    headers: {
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        staff_id: staff.id,
                        active: !staff.active,
                    }),
                }
            );

            if (!response.ok) {
                const errorData = await response.json();
                console.error("API error response:", errorData);
                throw new Error("Failed to update status");
            }

            setStaffData((prevData) =>
                prevData.map((s) =>
                    s.id === staff.id ? { ...s, active: !staff.active } : s
                )
            );

            toast.success(`Staff ${action.toLowerCase()}d successfully`);
        } catch (err) {
            console.error("Error updating staff status:", err);
            toast.error("Failed to update staff status.");
        }
    };

    return (
        <>
            <div className="bg-gray-50">
                <Header />
                <VertNav />
                <div className="p-4 md:p-8 md:ml-72">
                    <div className="bg-white shadow-xl rounded-[2.5rem] p-6 md:p-8 mx-auto">
                        <Toaster />

                        {/* Header and Add Button */}
                        <div className="flex justify-between items-center mb-5">
                            <h1 className="text-3xl font-semibold">
                                Staff Management
                            </h1>
                            <div className="flex gap-2">
                                <button
                                    className="flex items-center gap-1 px-4 py-2 rounded-full text-sm shadow-md font-medium transition-colors bg-blue-600 hover:bg-blue-700 text-white"
                                    onClick={() => setShowUploadModal(true)}
                                >
                                    <Upload fontSize="small" />
                                    Upload
                                </button>
                                <button
                                    className=" px-4 py-2 rounded-full text-sm shadow-md font-medium transition-colors bg-blue-600 hover:bg-blue-700 text-white"
                                    onClick={() => setShowAddStaffModal(true)}
                                >
                                    + Add Staff
                                </button>
                            </div>
                        </div>

                        {/* Table */}
                        <div className="overflow-y-auto">
                            <table className="w-full bg-white shadow-md p-4 rounded-[2.5rem] overflow-hidden">
                                <thead className="bg-gray-50">
                                    <tr>
                                        {[
                                            "SNo.",
                                            "Name",
                                            "Role",
                                            "Mobile",
                                            "Salary",
                                            "Advance Paid",
                                            "Commission",
                                            "Attendance MTD",
                                            "Business MTD",
                                            "Mark Attendance",
                                            "Salary Slip",
                                            "Enable/Disable",
                                            "Actions",
                                        ].map((head, i) => (
                                            <th
                                                key={i}
                                                className="px-4 py-2 text-left border"
                                            >
                                                {head}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {staffData.map((staff, index) => (
                                        <tr
                                            key={staff.id}
                                            className="hover:bg-gray-50"
                                        >
                                            <td className="px-4 py-2 border text-center">
                                                {index + 1}
                                            </td>
                                            <td className="px-4 py-2 border text-center ">
                                                {staff.name}
                                            </td>
                                            <td className="px-4 py-2 border text-center">
                                                {staff.role}
                                            </td>
                                            <td className="px-4 py-2 border text-center">
                                                {staff.mobile}
                                            </td>
                                            <td className="px-4 py-2 border text-center">
                                                {staff.salary}
                                            </td>
                                            <td className="px-4 py-2 border text-center">
                                                {staff.advance || 0}
                                            </td>
                                            <td className="px-4 py-2 border text-center">
                                                {staff.commission}
                                            </td>
                                            <td className="px-6 py-4 text-center border text-sm text-gray-700">
                                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                                    {`${staff.attendance.present}/${staff.attendance.total}`}
                                                </span>
                                            </td>
                                            <td className="px-4 py-2 border text-center">
                                                {staff.business}
                                            </td>
                                            <td className="px-4 py-2 border text-center">
                                                <button
                                                    className="w-full px-4 py-2 rounded-full text-sm shadow-md font-medium transition-colors bg-blue-600 hover:bg-blue-700 text-white"
                                                    onClick={() =>
                                                        openAttendancePopup(
                                                            staff.id
                                                        )
                                                    }
                                                >
                                                    Mark
                                                </button>
                                            </td>
                                            <td className="px-4 py-2 border text-center">
                                                <button
                                                    className="w-full px-4 py-2 rounded-full text-sm shadow-md font-medium transition-colors bg-blue-600 hover:bg-blue-700 text-white"
                                                    onClick={() =>
                                                        openSalarySlipPopup(
                                                            staff.id
                                                        )
                                                    }
                                                >
                                                    Slip
                                                </button>
                                            </td>
                                            <td className="px-4 py-2 border text-center">
                                                <Switch
                                                    checked={!!staff.active}
                                                    color="primary"
                                                    onChange={() =>
                                                        handleToggleActive(
                                                            staff
                                                        )
                                                    }
                                                    inputProps={{
                                                        "aria-label":
                                                            "enable disable toggle",
                                                    }}
                                                />
                                                <span
                                                    className={
                                                        staff.active
                                                            ? "text-success"
                                                            : "text-danger"
                                                    }
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {staff.active
                                                        ? "Enabled"
                                                        : "Disabled"}
                                                </span>
                                            </td>
                                            <td className="px-4 py-2 border text-center">
                                                <IconButton
                                                    onClick={() =>
                                                        userType !== "staff" &&
                                                        handleEditStaff(staff)
                                                    }
                                                    disabled={
                                                        userType === "staff"
                                                    }
                                                    sx={{
                                                        opacity:
                                                            userType === "staff"
                                                                ? 0.5
                                                                : 1,
                                                        cursor:
                                                            userType === "staff"
                                                                ? "not-allowed"
                                                                : "pointer",
                                                    }}
                                                >
                                                    <Edit />
                                                </IconButton>

                                                <IconButton
                                                    onClick={() =>
                                                        userType !== "staff" &&
                                                        openDeleteConfirm(
                                                            staff.id
                                                        )
                                                    }
                                                    color="error"
                                                    aria-label="delete"
                                                    disabled={
                                                        userType === "staff"
                                                    }
                                                    sx={{
                                                        opacity:
                                                            userType === "staff"
                                                                ? 0.5
                                                                : 1,
                                                        cursor:
                                                            userType === "staff"
                                                                ? "not-allowed"
                                                                : "pointer",
                                                    }}
                                                >
                                                    <Delete />
                                                </IconButton>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Modals */}
                        {showAttendancePopup && (
                            <AttendancePopup
                                onClose={() => setShowAttendancePopup(false)}
                                onAttendanceMarked={handleAttendanceMarked}
                                staffId={selectedStaffId}
                                initialAttendance={
                                    staffData.find(
                                        (staff) => staff.id === selectedStaffId
                                    )?.attendance
                                }
                            />
                        )}

                        {showSalarySlipPopup && (
                            <SalarySlipPopup
                                onClose={() => setShowSalarySlipPopup(false)}
                                staffId={selectedStaffId}
                            />
                        )}

                        {showAddStaffModal && (
                            <AddStaffModal
                                onClose={() => setShowAddStaffModal(false)}
                                onAddStaff={handleAddStaff}
                            />
                        )}

                        {showEditStaff && (
                            <EditStaff
                                isOpen={showEditStaff}
                                onClose={() => setShowEditStaff(false)}
                                staffData={selectedStaff}
                                onSave={handleSaveEditedStaff}
                            />
                        )}

                        {deleteConfirmation && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                                <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-[90%] text-center">
                                    <h2 className="text-xl font-semibold mb-4">
                                        Are you sure you want to delete this
                                        staff member?
                                    </h2>
                                    <div className="flex justify-center gap-4 mt-6">
                                        <button
                                            className="bg-blue-500 hover:bg-blue-700 text-white py-2 px-6 rounded transition-colors"
                                            onClick={handleDeleteStaff}
                                        >
                                            Yes
                                        </button>
                                        <button
                                            className="bg-red-500 hover:bg-red-700 text-white py-2 px-6 rounded transition-colors"
                                            onClick={() =>
                                                setDeleteConfirmation(false)
                                            }
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {showUploadModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-[90%]">
                            <div className="flex justify-between items-center mb-4">
                                <h2 className="text-xl font-semibold">
                                    Upload Attendance
                                </h2>
                                <button
                                    onClick={() => setShowUploadModal(false)}
                                    className="text-gray-500 hover:text-red-700"
                                >
                                    <Close />
                                </button>
                            </div>

                            <div className="mb-4">
                                <label className="block text-base font-medium text-black mb-1">
                                    Select Device Make
                                </label>
                                <select
                                    className="w-full p-2 border border-gray-300 rounded-md"
                                    value={selectedDevice}
                                    onChange={(e) =>
                                        setSelectedDevice(e.target.value)
                                    }
                                >
                                    <option value="">Select Device</option>
                                    {deviceOptions.map((device) => (
                                        <option
                                            key={device.value}
                                            value={device.value}
                                        >
                                            {device.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="mb-6">
                                <label className="block text-base font-medium text-black mb-1">
                                    Upload Excel Sheet
                                </label>
                                {selectedFile ? (
                                    <div className="border border-gray-300 rounded-md p-6 h-32 flex flex-col justify-center">
                                        {" "}
                                        {/* Increased height */}
                                        <div className="flex justify-between items-center">
                                            <div>
                                                <p className="font-medium text-lg">
                                                    {fileName}
                                                </p>{" "}
                                                {/* Increased text size */}
                                                <p className="text-sm text-gray-500 mt-1">
                                                    Team Office
                                                </p>
                                            </div>
                                            <button
                                                onClick={handleRemoveFile}
                                                className="text-blue-600 hover:text-blue-800 text-sm"
                                            >
                                                Edit?
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="border-2 border-dashed border-gray-300 rounded-md p-8 text-center h-32 flex flex-col items-center justify-center">
                                        {" "}
                                        {/* Increased height */}
                                        <CloudUpload className="mx-auto text-gray-400 text-5xl w-8 h-8" />{" "}
                                        {/* Increased icon size */}
                                        <p className="mt-2 text-sm text-gray-600">
                                            Accepted Formats: .csv, .xls, .xlsx
                                        </p>
                                        <input
                                            type="file"
                                            id="file-upload"
                                            className="hidden"
                                            accept=".csv,.xls,.xlsx"
                                            onChange={handleFileChange}
                                        />
                                        <label
                                            htmlFor="file-upload"
                                            className="mt-3 inline-flex items-center px-4 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200 cursor-pointer"
                                        >
                                            Select File
                                        </label>
                                    </div>
                                )}
                            </div>

                            <button
                                className={`w-full px-4 py-3 rounded-md text-white ${
                                    selectedDevice && selectedFile
                                        ? "bg-blue-600 hover:bg-blue-700"
                                        : "bg-gray-400 cursor-not-allowed"
                                }`}
                                onClick={handleUpload}
                                disabled={!selectedDevice || !selectedFile}
                            >
                                Continue
                            </button>
                        </div>
                    </div>
                )}
                {showUploadResultModal && uploadResultData && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-2xl">
                            <div className="flex justify-between items-center mb-4">
                                <h2 className="text-xl font-semibold">
                                    Upload Excel Sheet
                                </h2>
                                <button
                                    onClick={() =>
                                        setShowUploadResultModal(false)
                                    }
                                    className="text-gray-500 hover:text-gray-700"
                                >
                                    <Close />
                                </button>
                            </div>

                            <div className="mb-6">
                                <div className="mb-4">
                                    <div className="flex gap-16">
                                        <h3 className="text-lg font-medium mb-2">
                                            Dates:
                                        </h3>
                                        <div>
                                            <p className="text-sm text-gray-600">
                                                From
                                            </p>
                                            <p className="font-medium">
                                                10/11/2025
                                            </p>
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-600">
                                                To
                                            </p>
                                            <p className="font-medium">
                                                10/11/2025
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <h3 className="text-lg font-medium mb-2">
                                        Employees
                                    </h3>

                                    {/* Employee 1 */}
                                    <div className="mb-6">
                                        <p className="font-medium mb-2">
                                            Promoth{" "}
                                        </p>
                                        <table className="w-full border-collapse">
                                            <thead>
                                                <tr className="bg-gray-100">
                                                    <th className="border p-2 text-left">
                                                        Date
                                                    </th>
                                                    <th className="border p-2 text-left">
                                                        In Time
                                                    </th>
                                                    <th className="border p-2 text-left">
                                                        Out Time
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="border p-2">
                                                        10/11/2025
                                                    </td>
                                                    <td className="border p-2">
                                                        10:50AM
                                                    </td>
                                                    <td className="border p-2">
                                                        9:00PM
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="border p-2">
                                                        11/11/2025
                                                    </td>
                                                    <td className="border p-2">
                                                        10:30AM
                                                    </td>
                                                    <td className="border p-2">
                                                        9:00PM
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Employee 2 */}
                                    <div className="mb-6">
                                        <p className="font-medium mb-2">
                                            sarthak
                                        </p>
                                        <table className="w-full border-collapse">
                                            <thead>
                                                <tr className="bg-gray-100">
                                                    <th className="border p-2 text-left">
                                                        Date
                                                    </th>
                                                    <th className="border p-2 text-left">
                                                        In Time
                                                    </th>
                                                    <th className="border p-2 text-left">
                                                        Out Time
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="border p-2">
                                                        10/11/2025
                                                    </td>
                                                    <td className="border p-2">
                                                        10:50AM
                                                    </td>
                                                    <td className="border p-2">
                                                        9:00PM
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="border p-2">
                                                        11/11/2025
                                                    </td>
                                                    <td className="border p-2">
                                                        10:30AM
                                                    </td>
                                                    <td className="border p-2">
                                                        9:00PM
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div className="flex justify-end">
                                <button
                                    className="px-6 py-2 bg-blue-600 text-white rounded-full hover:bg-blue-700"
                                    onClick={() =>
                                        setShowUploadResultModal(false)
                                    }
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default AdminManagement;
